<template>
  <!-- <el-form-item :label="currentField.label" :label-width="currentField.labelWidth + 'px'">
    <el-time-select
      v-model="currentField.componentValue"
      :picker-options="{
        start: '00:00',
        step: '00:15',
        end: '23:45'
      }"
      placeholder="Select time"
      v-on:change="timePickerChange"
    ></el-time-select>
  </el-form-item> -->

  <div class="date-pick el-form-item">
    <el-form-item
        :label="currentField.label" :label-width="currentField.labelWidth + 'px'">
    </el-form-item>
    <div class="el-form-item__content">
      <div class="el-input">
        <app-input
          type="time"
          placeholder="Select time" 
          v-on:change="timePickerChange"
          v-model="currentField.componentValue"
          v-bind="attributesBinding"
        />
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'TimePicker',
  props: ['currentField'],
  data() {
    return {
      // time: ''
    };
  },
  methods: {
    timePickerChange(value) {
      this.currentField.componentValue = value;
    }
  },
  computed: {
    attributesBinding() {
      var attr = {};

      if (this.currentField.disabled) {
        attr.disabled = this.currentField.disabled;
      }
      return attr;
    }
  },
};
</script>
<style>

.date-pick .time-picker-input {
  max-width: 50% !important;
}
</style>